import BaseFormPresenter from "../../../base/BaseFormPresenter";

class ForgotFormPagePresenter extends BaseFormPresenter {
  constructor(
    view,
    getObjectUseCase,
    upsertUseCase,
    updateObjectUseCase,
    getCurrentUserUseCase,
  ) {
    super();
    this.view = view;
    this.getObjectUseCase = getObjectUseCase;
    this.upsertUseCase = upsertUseCase;
    this.updateObjectUseCase = updateObjectUseCase;
    this.getCurrentUserUseCase = getCurrentUserUseCase;
  }

  async getUser(session) {
    const options = {
      session: session,
    };

    try {
      const user = await this.getCurrentUserUseCase.execute(options);
      console.log("user", user);
      if (user && typeof user === "object") {
        return user;
      } else {
        throw new Error("Invalid response structure");
      }
    } catch (error) {
      console.error("Error fetching user:", error);
      this.view.navigateTo("/expired");
    }
  }

  async save(user, session) {
    const collection = this.view.getCollectionName();

    const options = {
      session: session,
    };

    try {
      await this.updateObjectUseCase.execute(collection, user, options);
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }

  validatePassword(newPassword, confirmNewPassword) {
    if (newPassword !== confirmNewPassword) {
      return "Password must be the same.";
    }

    if (newPassword.length < 8 || newPassword.length > 16) {
      return "Password length must be 8-16 characters.";
    }

    const validation =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])(?=.*\d)[A-Za-z\d@$!%*?&]+$/;

    if (!validation.test(newPassword)) {
      return "Password must contain at least one uppercase letter, one lowercase letter, one special character, and one number.";
    }

    return null;
  }

  async submit() {
    const { password, confirmPassword } = this.change;
    const sessionId = this.view.getSessionId();

    if (password !== confirmPassword) {
      this.view.showError("Confirm Password doesn't match the New Password");
      return;
    }

    const errorMessage = this.validatePassword(password, confirmPassword);

    if (errorMessage) {
      this.view.showError(errorMessage);
      return;
    }

    delete this.change.confirmPassword;

    try {
      this.view.showProgress();
      this.view.submitting();

      const user = await this.getUser(sessionId);
      const { roles, ...updatedUser } = user;
      updatedUser.password = password;

      await this.save(updatedUser, sessionId);
      this.view.submissionSuccess();
      this.view.showSuccessSnackbar("Password SuccessFully updated!");
      this.view.hideProgress();
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
      console.error("error", error);
      this.view.hideProgress();
    }
  }
}

export default ForgotFormPagePresenter;
